import React from 'react';
import { useTranslation } from 'react-i18next';

function BestPlace() {
    const { t } = useTranslation();
    return (
        <section className="">
            <div className="tf-container">
                <div className="row justify-content-center">

                    {/* Title */}
                    <div className="col-md-12 text-center">
                        <div className="tf-heading my-5 wow fadeInUp">
                            <h2 className="heading" style={{ textAlign: "center" }}>
                                {t('best_place_to_buy_fc_coins')}
                            </h2>
                        </div>
                    </div>

                    {/* Image - Centered */}
                    <div className="col-md-12 text-center" data-aos="fade-up" data-aos-duration="800">

                    <p className="content-text" style={{ fontSize: "16px" }}>
                                {t('why_we_are_the_best_place_to_buy_fc_coins_text')}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t('why_we_are_the_best_place_to_buy_fc_coins_text2')}

                            </p>
                    </div>

                    {/* Main Content */}
                    <div className="col-md-12 mt-4">
                        <div className="content-box" style={{ padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)" }}>

                        <div className="content-box w-100" style={{ padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)" }}>
                            <img 
                                src="images/pages/fc6.jpg" 
                                alt={t('Best Place to Buy FC Coins')} 
                                className="img-fluid" 
                                style={{ width: "100%", maxHeight: "500px", borderRadius: "8px" }} 
                            />
                        </div>
                            {/* <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>

                                {t('why_we_are_the_best_place_to_buy_fc_coins')}
                            </h3> */}
                           

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('competitive_prices_best_deals')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t('competitive_prices_best_deals_text')}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t('competitive_prices_best_deals_text2')}
                            </p>


                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('fast_secure_transactions')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t('fast_secure_transactions_text')}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t('fast_secure_transactions_text2')}
                            </p>

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('trusted_by_thousands_of_gamers')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t('trusted_by_thousands_of_gamers_text')}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t('trusted_by_thousands_of_gamers_text2')}
                            </p>

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('24_7_customer_support')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t('24_7_customer_support_text3')}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t('24_7_customer_support_text4')}
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default BestPlace;
